export default __webpack_public_path__ + "static/media/G0250.Medical_Emergencies_in_Adults_2.1657620960000.0fc3894d.jpg";